var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-app',[_c('left-drawer'),_c('v-app-bar',{attrs:{"dense":"","app":"","color":"#0066cc"}},[_c('v-app-bar-title',{staticClass:"white--text"},[_vm._v("LEA - Lista enti asseverabili")]),_c('v-spacer')],1),_c('v-main',[_c('v-container',{attrs:{"fluid":""}},[_c('router-view')],1)],1),_c('v-footer',{attrs:{"app":""}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }